import { render } from "./singlePost.vue?vue&type=template&id=74cf5489"
import script from "./singlePost.vue?vue&type=script&lang=js"
export * from "./singlePost.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Plopfox\\Documents\\Julian\\Dev\\Repositorios\\folleselavida-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__